import PropTypes from 'prop-types';

export const blogPostProps = {
  byline: PropTypes.string,
  content: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string,
  thumbnailImage: PropTypes.string,
  title: PropTypes.string,
  updatedDate: PropTypes.string,
  url: PropTypes.string,
};

export const blogPost = PropTypes.shape(blogPostProps);
